export const EDisbursementStatus = {
  Canceled: "canceled",
  NetPayVoid: "net_pay_void",
  Pending: "pending",
  Refunded: "refunded",
  Returned: "returned",
  Settled: "settled",
} as const;

export type EDisbursementStatus =
  (typeof EDisbursementStatus)[keyof typeof EDisbursementStatus];
